import * as svg from "../../../assets/connected-round-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const ConnectedRoundIcon = iconBuilder(svg, "ConnectedRoundIcon", "0 0 20 20");
